import { memo, type ReactNode, useId } from 'react';

import { Switch } from '@air/primitive-switch';

import { ShareModalRow } from '~/components/ShareModal/components/ShareModalRow';

export type OnOffShareToggleRowProps = {
  label: string;
  labelAccessory?: ReactNode;
  checked: boolean;
  isLoading?: boolean;
  disabled?: boolean;
  onToggle: (checked: boolean) => void;
  'data-testid'?: string;
};

export const OnOffShareToggleRow = memo(
  ({
    label,
    labelAccessory,
    checked,
    isLoading,
    disabled,
    onToggle,
    'data-testid': dataTestId,
  }: OnOffShareToggleRowProps) => {
    const id = useId();

    return (
      <ShareModalRow data-testid={dataTestId} htmlFor={id} label={label} labelAccessory={labelAccessory}>
        <span className="ads:text-metadata text-12 text-gray-10">{checked ? 'ON' : 'OFF'}</span>
        <Switch checked={checked} disabled={disabled} id={id} isLoading={isLoading} onCheckedChange={onToggle} />
      </ShareModalRow>
    );
  },
);

OnOffShareToggleRow.displayName = 'OnOffShareToggleRow';
